import { Dispatch, SetStateAction, useState } from "react";

import { useTranslation } from "react-i18next";

import { removeSlashFromPath } from "@/shared/functions/functions";
import { useTableStoreByRoute } from "@/stores/useTableStore";

import { RemoveCircleOutlineIcon } from "@dotnet/telematics-design-system";

import {
  MenuAnchorEl,
  ROUTES,
  tableNameParams
} from "../../../../../../../shared";
import ListChoice from "../../../../../../ListChoice/ListChoice";
import { DriverScheduleDto, ScheduleDto } from "../../../../../types";
import RemoveScheduleDialog from "./RemoveScheduleDialog";

interface IRemoveScheduleButtonProps {
  route: ROUTES;
  schedule: ScheduleDto | DriverScheduleDto;
  onActionsMenu?: Dispatch<SetStateAction<MenuAnchorEl>>;
}

const RemoveScheduleButton = ({
  route,
  schedule,
  onActionsMenu
}: IRemoveScheduleButtonProps) => {
  const { t } = useTranslation();

  const { detailsData } = useTableStoreByRoute(route);

  const resourceName = removeSlashFromPath(route);

  const [isOpen, setIsOpen] = useState(false);

  const handleOpenRemoveScheduleDialog = () => {
    setIsOpen(true);
  };

  const handleCloseRemoveScheduleDialog = () => {
    setIsOpen(false);
    onActionsMenu?.(null);
  };
  const resourceParams = tableNameParams[resourceName] || {};

  return (
    <>
      <ListChoice
        title={t("Details##remove")}
        iconLeft={<RemoveCircleOutlineIcon />}
        onClick={handleOpenRemoveScheduleDialog}
        alignIconCenter
      />

      <RemoveScheduleDialog
        schedule={schedule}
        resourceParams={resourceParams}
        resourceId={detailsData?.id}
        isOpen={isOpen}
        handleClose={handleCloseRemoveScheduleDialog}
      />
    </>
  );
};

export default RemoveScheduleButton;
